<template>
  <div class="flex flex-col items-center justify-between full-height">
    <div class="w-full">
      <div class="relative mb-4">
        <p class="font-bold mb-5">Enter your registered business name.</p>
        <div key="comboBox" v-ClickOutside="hideIfClick">
          <DrInput
            ref="search"
            v-model="businessName"
            data-cy="business-name"
            class="mb-1"
            placeholder="Registered business"
            :icon="businessName && isValidBusiness ? 'checkmark-solid' : ''"
            icon-color="green-500"
            @focus="focus = true"
            @input="companyView"
            @keyup.esc="hideAll"
          />
          <CompanySearch
            v-if="businessName.length && showCompanies && focus"
            ref="companySearch"
            :business-name="businessName"
            @change="selectCompany"
            @hideContinue="isValidBusiness = false"
          />
          <DirectorsSearch
            v-if="businessNumber && showOfficers && focus"
            ref="directorsSearch"
            :business-number="businessNumber"
            @change="selectOfficer"
          />
        </div>
      </div>
      <p class="mb-8 text-center seperator text-grey-550">OR</p>
      <DrButton
        class="btn-outline btn-block btn-blue"
        data-cy="btn-non-registered-company"
        @click.prevent="removeBusinessDetails"
      >
        I'm not a registered business
      </DrButton>
    </div>
    <Transition name="fade">
      <div v-if="showContinue" class="w-full mt-6">
        <RouterLink to="/business-activities" class="no-underline w-full">
          <DrButton class="btn-block btn-blue">Continue</DrButton>
        </RouterLink>
      </div>
    </Transition>
  </div>
</template>

<script>
/* eslint-disable no-useless-escape */
import formatNameMixin from '../../mixins/FormatName'
import ClickOutside from '../../directives/ClickOutside'
import DirectorsSearch from './DirectorsSearch.vue'
import CompanySearch from './CompanySearch.vue'

export default {
  components: {
    CompanySearch,
    DirectorsSearch,
  },
  directives: {
    ClickOutside,
  },
  mixins: [formatNameMixin],
  data () {
    return {
      focus: false,
      showCompanies: false,
      showOfficers: false,
      loading: false,
      debounceTimeout: null,
    }
  },
  computed: {
    businessName: {
      get () {
        return this.$store.getters.getBusinessName
      },
      set (value) {
        this.$store.commit('updateBusinessName', value)
      },
    },
    businessNumber: {
      get () {
        return this.$store.getters.getBusinessNumber
      },
      set (value) {
        this.$store.commit('updateBusinessNumber', value)
      },
    },
    isValidBusiness: {
      get () {
        return this.$store.getters.getIsValidBusiness
      },
      set (value) {
        this.$store.commit('updateIsValidBusiness', value)
      },
    },
    firstName: {
      get () {
        return this.$store.getters.getFirstName
      },
      set (value) {
        this.$store.commit('updateFirstName', value)
      },
    },
    lastName: {
      get () {
        return this.$store.getters.getLastName
      },
      set (value) {
        this.$store.commit('updateLastName', value)
      },
    },
    showContinue () {
      return !!(this.businessName && this.isValidBusiness)
    },
    piRatingType: {
      get () {
        return this.$store.getters.getPiRatingType
      },
      set (value) {
        this.$store.commit('updatePiRatingType', value)
      },
    },
    premises: {
      get () {
        return this.$store.getters['premises/all']
      },
      set (value) {
        this.$store.commit('premises/setPremises', value)
        this.$store.commit('setPremises', this.premises)
      },
    },
  },
  mounted () {
    this.$refs.search.$refs.input.focus()
    this.$refs.search.$refs.input.style.textTransform = 'uppercase'
  },
  methods: {
    setFocus () {
      this.$refs.search.$refs.input.focus()
    },
    companyView () {
      this.showCompanies = true
      this.showOfficers = false
      this.showIndustries = false
    },
    hideAll () {
      this.$refs.search.$refs.input.blur()
      this.focus = false
    },
    hideIfClick () {
      if (!window.getSelection().toString()) this.hideAll()
    },
    removeBusinessDetails () {
      this.businessName = ''
      this.businessNumber = ''
      this.isValidBusiness = false
      this.premises = []
      this.$router.push('/business-activities')
    },
    selectCompany (company) {
      this.businessName = company.title
      this.businessNumber = company.company_number
      this.isValidBusiness = true
      this.companyOfficer = ''
      this.showCompanies = false
      this.showOfficers = true
      this.premises = [
        {
          line1: `${company.address.premises.replace(/\ $/, '')} ${company.address.address_line_1}`,
          line2: company.address.address_line_2,
          city: company.address.locality,
          postcode: company.address.postal_code,
          country: company.address.country,
        },
      ]
      this.setFocus()
    },
    selectOfficer (officer) {
      if (officer) {
        this.firstName = this.formatName(officer.name).firstName
        this.lastName = this.formatName(officer.name).lastName
      }
      this.showOfficers = false
      this.$router.push('/business-activities')
    },
  },
}
</script>

<style>
.seperator {
  position: relative;
  width: 100%;
}

.seperator::before,
.seperator::after {
  position: absolute;
  top: 50%;
  width: 40%;
  height: 1px;
  content: '';
  background-color: #8a9ba8;
  transform: translateY(-50%);
}

.seperator::before {
  left: 0;
}

.seperator::after {
  right: 0;
}
</style>
